export type PlatformId = 'instagram' | 'tiktok' | 'ugc';
export type TypeId =
  | 'reel'
  | 'post'
  | 'story'
  | 'carousel'
  | 'video'
  | 'photoCarousel'
  | 'ugcShort'
  | 'ugcMedium'
  | 'ugcLong'
  | 'ugcStory'
  | 'ugcPhoto'
  | 'ugcPhotoCarousel';

const PLATFORM_DROPDOWN_PREFIX: Record<PlatformId, string> = {
  instagram: 'Instagram',
  tiktok: 'TikTok',
  ugc: 'UGC',
};

export const TYPE_FOR_PLATFORM: Record<PlatformId, { value: TypeId; label: string }[]> = {
  instagram: [
    { value: 'reel', label: 'Reel' },
    { value: 'post', label: 'Post' },
    { value: 'story', label: 'Story' },
    { value: 'carousel', label: 'Carousel' },
  ],
  tiktok: [
    { value: 'video', label: 'Video' },
    { value: 'photoCarousel', label: 'Carousel' },
  ],
  ugc: [
    { value: 'ugcShort', label: 'Short form (0–30s)' },
    { value: 'ugcMedium', label: 'Medium form (30–60s)' },
    { value: 'ugcLong', label: 'Long form (60s+)' },
    { value: 'ugcStory', label: 'Story (15s vertical)' },
    { value: 'ugcPhoto', label: 'Photo' },
    { value: 'ugcPhotoCarousel', label: 'Photo Carousel' },
  ],
};

export type PackageContentTypeOption = {
  platform: PlatformId;
  type: TypeId;
  /** "Instagram — Reel" style; used in every package content-type menu. */
  dropdownLabel: string;
};

export const PACKAGE_CONTENT_TYPE_OPTIONS: PackageContentTypeOption[] = (
  (['instagram', 'tiktok', 'ugc'] as const)
).flatMap((platform) =>
  TYPE_FOR_PLATFORM[platform].map((o) => ({
    platform,
    type: o.value,
    dropdownLabel: `${PLATFORM_DROPDOWN_PREFIX[platform]} — ${o.label}`,
  }))
);

export function lineLabel(type: TypeId): string {
  const map: Record<TypeId, string> = {
    reel: 'Reel',
    post: 'Post',
    story: 'Story',
    carousel: 'Carousel',
    video: 'Video',
    photoCarousel: 'Carousel',
    ugcShort: 'Short form (0–30s)',
    ugcMedium: 'Medium form (30–60s)',
    ugcLong: 'Long form (60s+)',
    ugcStory: 'Story (15s vertical)',
    ugcPhoto: 'Photo',
    ugcPhotoCarousel: 'Photo Carousel',
  };
  return map[type];
}
